import axios, { AxiosError } from "axios";
import { env } from "@/env";
import { TelemetryService } from "@/services/TelemetryService";

const apiJdeClient = axios.create({
    baseURL: `${env.apiJde.origin}${env.apiJde.path}`,
    headers: {
        "x-functions-key": env.apiJde.key,
        "content-type": "application/json",
    },
});

apiJdeClient.interceptors.response.use(null, async (error: AxiosError) => {
    // Map to JavaScript error for App Insights
    const jsError = mapToError(error);

    // Log request error
    TelemetryService.logError(jsError, { url: error.config.url });

    return Promise.reject(error);
});

function mapToError(axiosError: AxiosError) {
    const error = new Error(axiosError.message);
    error.name = "API JDE request error";
    error.stack = axiosError.stack;

    return error;
}

export { apiJdeClient };
